export default {
  props: {
    time_created: {
      label: '建立时间',
      type: 'time',
    },
  },
  electricity: {
    orders: [
      'master',
      'lift',
      '1f_express',
      '4f',
      '5f',
      '5f_washer',
      '6f',
      '7f',
      '7f_kitchen',
      '7f_cafe',
      '7f_gym',
      '7f_car_cube',
      '8f',
      '8f_water',
    ],
    meters: {
      master: { label: '楼栋总电表(x60)' },
      lift: { label: '电梯表' },
      '4f': { label: '4F' },
      '5f': { label: '5F' },
      '6f': { label: '6F' },
      '7f': { label: '7F' },
      '8f': { label: '8F' },
      '7f_kitchen': { label: '7F厨房' },
      '7f_cafe': { label: '7F吧台餐厅' },
      '7f_gym': { label: '7F健身' },
      '8f_water': { label: '8F二次供水电表' },
      '7f_car_cube': { label: '7F车立方广告' },
      '1f_express': { label: '1F快递柜电表' },
      '5f_washer': { label: '5F公共洗衣机' },
    },
    computed: {
      '8f_hot_water': { label: '8F热水表', expression: '8f - 8f_water' },
      '7f_common': { label: '7F楼层', expression: '7f - 8f - 7f_gym - 7f_kitchen - 7f_cafe - 7f_car_cube' },
      '5f_common': { label: '5F楼层', expression: '5f - 5f_washer' },
      master_diff: { label: '总表差额', expression: 'master - 4f - 5f - 6f - 7f' },
    },
  },
  water: {
    orders: [
      'master',
      'hot_water',
      'washer',
      'kitchen',
      'cafe',
    ],
    meters: {
      master: { label: '总表' },
      hot_water: { label: '热水表' },
      washer: { label: '楼道公共洗衣机' },
      kitchen: { label: '厨房水表' },
      cafe: { label: '吧台水表' },
    },
    computed: {
      water: { label: '总冷水', expression: 'master - hot_water' },
      common: { label: '楼层冷水', expression: 'master - hot_water - washer - kitchen - cafe' },
    },
  },
}



// WEBPACK FOOTER //
// ./client/src/defines/meters.js